import { css } from 'styled-components';
import { themeGet, is } from '../../../theme/utils';
import { ButtonBaseProps } from '../Button';

const tertiary = css<ButtonBaseProps>`
  color: ${themeGet.colors('sandDune')};
  border: 2px solid ${themeGet.colors('swirl')};
  &:active {
    background-color: ${themeGet.colors('desertStorm')};
  }
  ${is('disabled')`
    color: ${themeGet.colors('swirl')};
    border: 2px solid ${themeGet.colors('swirl')};
  `};
`;

export default tertiary;
